import { AccordionDetails, Typography, Box, CircularProgress } from "@mui/material";
import React from "react";

import FormatISODateTime from "../../../../../global/FormatISODateTime";
import QuestionAndAnswerList from "../List/QuestionAndAnswerList";

export default function CustomFollowUpHistoryAccordionDetails({ data, loading = false }) {
  if (loading) {
    return (
      <AccordionDetails>
        <Box className="flex w-full items-center justify-center py-4">
          <CircularProgress size={20} color="secondary" />
        </Box>
      </AccordionDetails>
    );
  }

  if (!data) {
    return null;
  }

  const completedAtIso =
    data?.completedAt && typeof data.completedAt !== "string"
      ? new Date(data.completedAt).toISOString()
      : data?.completedAt || "";

  const completedAt = completedAtIso ? FormatISODateTime(completedAtIso) : "";
  const completedByName = data?.completedBy?.name || "";
  const formQnA = data?.formAnswers || [];

  return (
    <AccordionDetails className="flex flex-col gap-2">
      <div className="flex flex-col gap-2">
        <Typography className="flex w-full flex-row items-center text-[12px] font-medium">
          <span className="font-semibold">Completed At:&nbsp;</span>
          <span className="text-[12px]">{completedAt}</span>
        </Typography>

        <Typography className="flex w-full flex-row items-center text-[12px] font-medium">
          <span className="font-semibold">Completed By:&nbsp;</span>
          <span className="text-[12px]">{completedByName}</span>
        </Typography>
      </div>
      <QuestionAndAnswerList formQnA={formQnA} />
    </AccordionDetails>
  );
}
